import apiClient from './api.service';
import { DashboardData, DashboardStats, RecentOrder, StatusCountsMap } from '../types/dashboard.types';
import { BlockTimeConfig } from '../types/dashboardLayout.types';

const buildTimeParams = (config?: BlockTimeConfig): Record<string, string> => {
  if (!config) return {};
  if (typeof config === 'string') {
    return { timeWindow: config };
  }
  return {
    timeWindow: 'custom',
    start_at: config.start_at,
    end_at: config.end_at
  };
};

class DashboardService {
  async getStats(storeId: number, timeConfig?: BlockTimeConfig): Promise<DashboardStats> {
    const params = buildTimeParams(timeConfig);
    const response = await apiClient.get(`/stores/${storeId}/dashboard/stats`, { params });
    return response.data.data.stats;
  }

  async getRecentOrders(storeId: number, limit: number = 5, timeConfig?: BlockTimeConfig): Promise<RecentOrder[]> {
    const params: Record<string, string | number> = { limit, ...buildTimeParams(timeConfig) };
    const response = await apiClient.get(`/stores/${storeId}/dashboard/recent-orders`, { params });
    return response.data.data.recentOrders;
  }

  async getStatusCounts(storeId: number, timeConfig?: BlockTimeConfig): Promise<StatusCountsMap> {
    const params = buildTimeParams(timeConfig);
    const response = await apiClient.get(`/stores/${storeId}/dashboard/status-counts`, { params });
    return response.data.data.statusCounts ?? {};
  }

  async getPhaseCounts(storeId: number, timeConfig?: BlockTimeConfig): Promise<StatusCountsMap> {
    const params = buildTimeParams(timeConfig);
    const response = await apiClient.get(`/stores/${storeId}/dashboard/phase-counts`, { params });
    return response.data.data.phaseCounts ?? {};
  }

  async getDashboardData(
    storeId: number,
    timeWindows?: { statsTimeWindow?: BlockTimeConfig; ordersTimeWindow?: BlockTimeConfig }
  ): Promise<DashboardData> {
    const [stats, recentOrders] = await Promise.all([
      this.getStats(storeId, timeWindows?.statsTimeWindow),
      this.getRecentOrders(storeId, 5, timeWindows?.ordersTimeWindow)
    ]);

    return {
      stats,
      recentOrders
    };
  }
}

export default new DashboardService();

